export default __webpack_public_path__ + "static/media/brush.30226eda.svg";